import React, { useState } from "react";
import { ImagePlus } from "lucide-react";
import OwnerMediaModal from "./OwnerMediaModal";

/**
 * "Add Media" button on an owner card: opens the media manager, where photos
 * are picked, reviewed and removed before anything is saved.
 */
const OwnerAddMediaButton = ({ property, onUploaded, className = "" }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Add photos to this property"
        aria-label="Add photos to this property"
        className={`flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg border border-[#503691] bg-white px-2.5 py-1 text-xs font-medium text-[#503691] transition-colors hover:bg-[#503691] hover:text-white xl:gap-2 xl:px-3 xl:py-1.5 xl:text-sm ${className}`}
      >
        <ImagePlus className="h-3.5 w-3.5 xl:h-4 xl:w-4" />
        <span>Add Media</span>
      </button>

      {open && (
        <OwnerMediaModal
          property={property}
          onClose={() => setOpen(false)}
          onSaved={onUploaded}
        />
      )}
    </>
  );
};

export default OwnerAddMediaButton;
